import serviceType from 'constants/serviceType';
import axiosClient from './aixosClient';
import { AxiosResponse } from 'axios';
import { BaseResponse } from 'models/baseResponse';

const commonApi = {
    initMenuHeader(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'getVersion1';
        return axiosClient.post(serviceType.MOBILE_SERVICE, payload);
    },
    getMsgSystemBean(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'sysMessage';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    sysMsgBeanInfo(payload: { id: number; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'sysMessage_view';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
};
export default commonApi;
